// Package Features Mapping
// Maps package names to their included features
export const packageFeaturesMapping = {
  // Any Time Packages
  "Fiber Starter": "", // No additional features

  // Trio Packages
  "Trio Vibe": "Unlimited Voice & Peo TV 75 Channels",
  "Trio Vibe Plus": "Unlimited Voice & Peo TV 90 Channels",
  "Trio Shine": "Unlimited Voice & Peo TV 75 Channels",

  // Unlimited Packages
  "Unlimited Home": "Unlimited Voice",
  "Unlimited Home Plus": "Unlimited Voice",
  "Unlimited Twin": "Unlimited Voice",
  "Unlimited Pro": "Unlimited Voice",
  "Unlimited Edge": "Unlimited Voice",
  "Unlimited Turbo": "Unlimited Voice",

  // Ultra Packages
  "Ultra Prime": "Unlimited Voice",
  "Ultra Flash Prime": "Unlimited Voice",
};

/**
 * Get features string for a package
 * @param {string} packageName - The package name
 * @returns {string} Features string or empty string if no features
 */
export const getPackageFeatures = (packageName) => {
  if (!packageName) {
    return "";
  }

  return packageFeaturesMapping[packageName] || "";
};


